function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.001 2.225A5.3 5.3 0 0112.751.5a4.583 4.583 0 014.584 4.583c0 2.997-3.332 6.282-5.33 8.251l-.504.5-1.9 1.9a.625.625 0 01-.441.183h-.317a.625.625 0 01-.442-.184l-1.9-1.9c-.155-.155-.324-.321-.504-.499C4 11.364.668 8.08.668 5.084A4.583 4.583 0 015.251.5a5.3 5.3 0 013.75 1.725zm0 11.75l1.834-1.808c1.691-1.667 4.833-4.784 4.833-7.084a2.917 2.917 0 00-2.942-2.916 4.258 4.258 0 00-3.175 1.916.425.425 0 01-.333.167h-.375a.642.642 0 01-.5-.242 4.167 4.167 0 00-3.092-1.841 2.917 2.917 0 00-2.916 2.916c0 2.3 3.141 5.417 4.833 7.084l1.833 1.808z"
});

var SvgHeartOutlined = function SvgHeartOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    fill: "#D6D7E1"
  }, props), _ref);
};

export default SvgHeartOutlined;